// @ts-nocheck
class WIfooteraccor extends HTMLElement {
    connectedCallback() {
        this.toggleAccor();
    }

    toggleAccor() {
        const heading = this.querySelector('h3');
        if (!heading) return;
        const content = heading.nextElementSibling;
        const icon = heading.querySelector('.WI_move');
        const open = this.getAttribute('data-open') === 'true';

        if (open) {
            content.classList.add('WI_accor_para_active');
            if (icon) icon.style.transform = 'rotate(90deg)';
        }

        heading.addEventListener('click', (e) => {
            e.preventDefault();
            if (heading.getAttribute('data-noaccor') === 'true') {
                document.dispatchEvent(new CustomEvent('care:open', { bubbles: true }));
                return;
            }

            const isOpen = content.classList.toggle('WI_accor_para_active');
            if (icon) icon.style.transform = isOpen ? 'rotate(90deg)' : 'rotate(0deg)';
        });
    }
}

customElements.define('wi-accor', WIfooteraccor);